import { RootState } from "../state";

export const selectModals = (state: RootState) => state.ui.modals;

export const selectIsDatePickerOpen = (state: RootState) =>
  state.ui.isDatePickerOpen;
